import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcPartiesSolidComponent for rendering solid parties icon with optional gradient.
 */
@Component({
  selector: 'ic-parties-solid',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-parties-solid.html',
})
export class IcPartiesSolidComponent {
  /** The starting color of the icon gradient. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 19. */
  @Input() width: number | string = 19;

  /** The height of the icon. Defaults to 16. */
  @Input() height: number | string = 16;

  /** Solid color for the icon. */
  @Input() color = 'currentColor';

  /** Default color when no color or gradient is provided. */
  defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient. */
  gradientId = `partiesSolidGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if gradient is provided. */
  get hasGradient(): boolean {
    return !!(this.startColor && this.endColor);
  }
}
